import React from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'
import { useToast } from '@wartek-id/toast'
import { Spinner } from '@wartek-id/spinner'
import { historyUtils } from '@wartek-id/fe-toolbox'

import AndroidHandler from 'utils/androidHandler'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { useSETrackEventRefkom } from '../../hooks/useSETrackEventRefkom'
import {
  useApiUserDetailOnboarding,
  useMutateApiUserDetailOnboarding,
} from 'api/competency-mapping/useAPIUserDetail'

import type { RequestBodyUserDetailOnboarding } from 'types/competency-profile'

const onboardingImageSet = [
  {
    imgUrl: '/images/refleksi-kompetensi/img-onboarding-1.png',
  },
  {
    imgUrl: '/images/refleksi-kompetensi/img-onboarding-2.png',
  },
  {
    imgUrl: '/images/refleksi-kompetensi/img-onboarding-3.png',
  },
]

const Onboarding = () => {
  const router = useRouter()
  const toast = useToast()
  const androidHandler = AndroidHandler()
  const { trackOnboardingOpen } = useSETrackEventRefkom()

  const [step, setStep] = React.useState(0)

  const handlePrev = () => {
    if (step > 0) setStep(step - 1)
  }
  const onboardingType = 'REFLEKSI'

  const userDetailOnboardingMutation = useMutateApiUserDetailOnboarding()

  const validateOnboardingStatus = (OnboardingList) => {
    return OnboardingList.find(
      (Onboarding) =>
        Onboarding.onboardingType === onboardingType && Onboarding.onboarded
    )
  }

  const onboardingSubmit = () => {
    const payload: RequestBodyUserDetailOnboarding = {
      onboardingType,
      onboarded: true,
    }
    if (validateOnboardingStatus(UserDetailOnboarding?.data)) {
      router.push('/refleksi-kompetensi?source=onboarding')
    } else {
      userDetailOnboardingMutation.mutate(payload, {
        onSuccess: () => {
          refetchResult().then(() => {
            router.push('/refleksi-kompetensi?source=onboarding')
          })
        },
        onError: (error) => {
          // TODO: handle error
          toast({
            message:
              error?.originalError?.response?.data?.message ||
              error.description,
          })
        },
      })
    }
  }

  const handleNext = () => {
    if (step < 2) setStep(step + 1)
    else {
      onboardingSubmit()
    }
  }

  const {
    isLoading: isLoadingUserDetailOnboarding,
    isSuccess: isSuccessUserDetailOnboarding,
    data: UserDetailOnboarding,
    refetch: refetchResult,
  } = useApiUserDetailOnboarding(onboardingType)

  React.useEffect(() => {
    if (isSuccessUserDetailOnboarding) {
      trackOnboardingOpen({ pageIndex: step + 1 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUserDetailOnboarding, step])

  if (isLoadingUserDetailOnboarding)
    return (
      <div className="w-full flex justify-center">
        <Spinner />
      </div>
    )

  return (
    <div className="flex flex-col w-full h-[100dvh] m-auto bg-gray-10 overflow-hidden">
      <PageHeader
        title="Refleksi Kompetensi"
        hideRightAction
        icon="close"
        leftActionFunction={() => {
          historyUtils.backToApp(() => {
            const isOnboarded = validateOnboardingStatus(
              UserDetailOnboarding?.data
            )
            const notOnboardedAndroid = !isOnboarded && androidHandler.enabled
            const notOnboardedNotAndroid =
              !isOnboarded && !androidHandler.enabled

            if (isOnboarded) router.back()
            if (notOnboardedAndroid) androidHandler.backToApp()
            if (notOnboardedNotAndroid) router.push('/home')
          })
        }}
      />
      <div
        className="flex flex-col pt-[54px]"
        style={{ minHeight: 'calc(100svh - 74px)' }}
      >
        <img
          src={onboardingImageSet[step].imgUrl}
          alt="onboarding image"
          className="object-cover md:object-contain h-full min-h-full"
        />
      </div>
      <div
        className={clsx(
          'flex bg-white py-5 px-4 w-full bottom-0 mt-auto',
          step == 0 ? 'justify-end' : 'justify-between'
        )}
      >
        {step > 0 && (
          <Button size="md" variant="ghost" color="black" onClick={handlePrev}>
            <Icon fontSize="small" className="ml-1">
              chevron_left
            </Icon>
            Kembali
          </Button>
        )}
        <Button size="md" onClick={handleNext}>
          {step < 2 ? 'Lanjut' : 'Coba sekarang'}
          <Icon fontSize="small" color="inverse" className="ml-1">
            chevron_right
          </Icon>
        </Button>
      </div>
    </div>
  )
}

export default Onboarding
